define('TescoMobile_Customer/js/recaptcha-check',['jquery'], function ($) {
  'use strict';

  return function () {
    if (window.grecaptcha && window.grecaptcha.render) {
      $('#send2').removeAttr('disabled');
      $('#otac_coninue_btn').removeAttr('disabled');
    } else {
      $(window).on('recaptchaapiready', function () {
        $('#send2').removeAttr('disabled');
        $('#otac_coninue_btn').removeAttr('disabled');
      }.bind(this));
    }
  };
});

